import { useData } from "./DataContext.js";

import { TbSquareFilled, TbHelpSquareFilled, TbSquareChevronLeftFilled, TbSquareChevronRightFilled } from "react-icons/tb";


export default function ImpactIcons (props)
{
    const gData = useData();
    const report = gData.state.reports[props.solutionId];

    let posImpact = 0;
    let negImpact = 0;
    let noImpact = 0;
    let unknownImpact = 0;

    if (report.result === null)
    {
	posImpact = report.variables[props.variableId].pos.documentIds.reduce((impact, documentId) => impact + Math.abs(gData.content.documents[documentId].impact), 0);
	negImpact = report.variables[props.variableId].neg.documentIds.reduce((impact, documentId) => impact + Math.abs(gData.content.documents[documentId].impact), 0);
	noImpact = Math.max(0, 5 - (posImpact + negImpact));
    }

    else {
	const variableResult = report.result.variables[props.variableId];
	posImpact = variableResult.estPosImpact;
	negImpact = variableResult.estNegImpact;

	while (posImpact + negImpact > 5) { posImpact--; negImpact--; }

	if (variableResult.realImpact === variableResult.estPosImpact - variableResult.estNegImpact) noImpact = Math.max(0, 5 - (posImpact + negImpact));
	else unknownImpact = Math.max(0, 5 - (posImpact + negImpact));
    }

    const posImpactIcons = Array.from(Array(posImpact).keys()).map((index) => (<TbSquareChevronRightFilled key={index} className="fs-2 text-success"/>));
    const negImpactIcons = Array.from(Array(negImpact).keys()).map((index) => (<TbSquareChevronLeftFilled key={index} className="fs-2 text-danger"/>));
    const noImpactIcons = Array.from(Array(noImpact).keys()).map((index) => (<TbSquareFilled key={index} className="fs-2 text-secondary opacity-50"/>));
    const unknownImpactIcons = Array.from(Array(unknownImpact).keys()).map((index) => (<TbHelpSquareFilled key={index} className="fs-2 text-warning"/>));

    return (<span className="d-flex">{negImpactIcons}{unknownImpactIcons}{noImpactIcons}{posImpactIcons}</span>);
}


